"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.delete.confirm.title': 'Elimina Onboarding',
    'onboarding.delete.confirm.message': 'Sei sicuro di voler eliminare questa sessione di onboarding?',
};
